import {
  Directive,
  Input
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

import { BigDecimalService } from '../../core/services/big-decimal.service';
import { SessionService } from '../../sessions/session.service';

@Directive({
  selector : '[worNumberValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: NumberValidator
    }
  ]
})
export class NumberValidator implements Validator {
  private _defaultValidation = new RegExp(this.sessionService.currency().validation);

  @Input() max   ?: number;
  @Input() min    : number;
  @Input() round  : number;

  @Input('worNumberValidator') value: string;

  constructor (
    private bigDecimalService : BigDecimalService,
    private sessionService    : SessionService
  ) {}

  validate ( control: AbstractControl ) : { [ key: string ] : any } {
    const hasMin = this.min !== null && this.min !== undefined;
    const typed  = typeof control.value === 'string'
      ? control.value.trim()
      : control.value;

    // Empty is valid, as is a lone '.' or '-' while a number below one or below zero is typed; spaces alone are not.
    if ( !control.value
      || ( ( !hasMin || this.min < 1 ) && typed === '.' )
      || ( ( !hasMin || this.min < 0 ) && typed === '-' )
    ) {
      return null;
    }

    if ( typed && this._defaultValidation.test(typed) ) {
      const max   = this.bigDecimalService.get(this.max);
      const value = this.bigDecimalService.get(typed);

      if ( hasMin && value.isLessThan(this.bigDecimalService.get(this.min)) ) {
        return { min: true };
      }

      if ( this.max && this.max !== 0 && value.isGreaterThan(max) ) {
        return { max: true };
      }

      return null;
    }

    return { number: true };
  }
}